"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getStatesByCountry = getStatesByCountry;
Object.defineProperty(exports, "USAStates", {
  enumerable: true,
  get: function () {
    return _usaStates.default;
  }
});
Object.defineProperty(exports, "CAStates", {
  enumerable: true,
  get: function () {
    return _caStates.default;
  }
});
exports.UsaAndCaStatesForDropdown = exports.CAStatesOpts = exports.USAStatesOpts = void 0;

var _usaStates = _interopRequireDefault(require("./usa-states"));

var _caStates = _interopRequireDefault(require("./ca-states"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
    TODO This files should be deprecated ASAP
    Please replace usages with src/definitions/countries-and-states/index.js
*/
const USAStatesOpts = _usaStates.default.map(state => ({
  optLabel: state.name,
  optValue: state.code
}));

exports.USAStatesOpts = USAStatesOpts;

const CAStatesOpts = _caStates.default.map(state => ({
  optLabel: state.name,
  optValue: state.code
}));

exports.CAStatesOpts = CAStatesOpts;
const UsaAndCaStatesForDropdown = [{
  optGroupLabel: 'Canada',
  options: CAStatesOpts
}, {
  optGroupLabel: 'United States',
  options: USAStatesOpts
}];
exports.UsaAndCaStatesForDropdown = UsaAndCaStatesForDropdown;
const stateMappingsByCountry = {
  ca: CAStatesOpts,
  us: USAStatesOpts
};

function getStatesByCountry(countryCode) {
  return stateMappingsByCountry[countryCode];
}